module.exports = __webpack_public_path__ + "static/media/ulip.0b3b3793.mp3";